import React from 'react';

import AppStores from 'components/bizos/app-stores';
import BizosList, { BizosListItem } from 'components/bizos/bizos-list';
import BizosTypography from 'components/bizos/bizos-typography';
import BizosLogo from 'components/bizos/bizos-logo';

import './bizon-final-screen.scss';

type BizonFinalScreenProps = {
    email: string,
    deepLinking?: string;
    onClick?: () => void;
};

const BizonFinalScreen: React.FC<BizonFinalScreenProps> = ({ email }) => {

    return (
        <div className="bizon-final-screen">
            <div className="bizon-final-screen__container bizon-final-screen__container--radius-top">
                <header className="bizon-final-screen__header">
                    <BizosTypography variant="heading-1" weight="bold">
                        pronto! seu pedido de crédito está sendo analisado 🎉
                    </BizosTypography>
                    <BizosTypography variant="subtitle" color="gray">
                        Em breve vamos entrar em contato por e-mail.
                    </BizosTypography>
                </header>
            </div>
            <hr className="bizon-final-screen__divider hidden-sm" />
            <div className="bizon-final-screen__container bizon-final-screen__container--shadow">
                <div className="bizon-final-screen__content">
                    <BizosLogo />
                    <BizosTypography color="gray">
                        Receba seu crédito na nossa
                        <BizosTypography variant="text" weight="bold" color="gray"> conta PJ digital <br className="hidden-sm" />gratuita </BizosTypography>
                        e aproveite!
                    </BizosTypography>
                    <BizosList>
                        <BizosListItem color="gray" icon="arrows">
                            TED e Pix <strong>grátis</strong>
                        </BizosListItem>
                        <BizosListItem color="gray" icon="barcode">
                            Quite seus boletos e<strong> pague após 30<br className="hidden-lg" /> dias com o Mais Biz*</strong>
                            <br />
                            <small>*sujeito à análise. CET de até 10% a.m.</small></BizosListItem>
                        <BizosListItem color="gray" icon="clock">Termine o cadastro em minutos usando <br className="hidden-md" />o mesmo e-mail <br className="hidden-sm" />do seu pedido de crédito: <strong>{email}</strong></BizosListItem>
                    </BizosList>
                    <AppStores text="aponte a câmera do seu celular para o QR code para acessar a loja de aplicativos" />
                </div>
            </div>
        </div>
    );
};

export default BizonFinalScreen;
